import * as React from "react";

interface IAvailability {
    isDisabled: boolean;
}

const Availability: React.FunctionComponent<IAvailability> = (props) => {
    return (
        <React.Fragment>
            {
                props.isDisabled ?
                    <span className="item-state grey">Disabled</span> :
                    <span className="item-state green">Enabled</span>
            }
        </React.Fragment>
    );
};

export default Availability;